import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getParameterByName } from '../../../../helpers/location';
import PlayersListWidget from '../Widgets/PlayersList'

const PlayersDashboard = props => (
    <div id="players-dashboard">
        <header className="content-header">
            <h1>
                Full players
                <small>dashboard</small>
            </h1>
            <ol className="breadcrumb">
                <li><i className="fa fa-desktop"/> On Site</li>
                <li className="text-bold"><Link to="/fullPlayers">Full players</Link></li>
            </ol>
        </header>
        <section className="content">
            <PlayersListWidget championship={parseInt(getParameterByName('championship', props.location.search), 10)} />
        </section>
    </div>
);

export default connect(
    state => ({}),
    dispatch => ({ dispatch }),
)(PlayersDashboard);



// WEBPACK FOOTER //
// ./src/pages/OnSite/FullPlayers/Dashboard/index.js